export const CASCOON_CONTAINER_CLASS_NAME = 'app';
